<ng-container *ngIf="viewModel$ | async as vm">
  <div
    class="availability-date-card jobsv2-{{ colorScheme.colorScheme.value }}"
    [ngClass]="vm.colorClass"
  >
    <div class="date-header-row">
      <div class="date-header">{{ vm.formattedDate }}</div>
      <div
        *ngIf="vm.tier && showTier"
        class="tier-badge"
        [style.background]="vm.tier.color || '#3b82f6'"
        [title]="vm.tier.name + ': ' + (vm.tier.percent > 0 ? '+' : '') + vm.tier.percent + '%'"
      >
        {{ vm.tier.name }}
        <span class="tier-percent">{{ vm.tier.percent > 0 ? '+' : '' }}{{ vm.tier.percent }}%</span>
      </div>
    </div>

    <div class="availability-row">
      <div class="availability-item">
        <app-availability-icon
          [total]="vm.trucksTotal"
          [available]="vm.trucksAvailable"
          icon="pi pi-chart-bar"
        ></app-availability-icon>
        <span class="availability-label">Trucks Available:</span>
        <span class="availability-value"
          >{{ vm.trucksAvailable }}/{{ vm.trucksTotal }}</span
        >
      </div>

      <div class="availability-item">
        <app-availability-icon
          [total]="vm.crewTotal"
          [available]="vm.crewAvailable"
          icon="pi pi-chart-bar"
        ></app-availability-icon>
        <span class="availability-label">Crew Available:</span>
        <span class="availability-value"
          >{{ vm.crewAvailable }}/{{ vm.crewTotal }}</span
        >
      </div>
    </div>

    <p-message
      *ngIf="vm.remark"
      class="availability-item"
      [severity]="vm.remark.severity"
      [text]="vm.remark.text"
    ></p-message>
  </div>
</ng-container>
